<template>
    <div ref="target">
        <slot></slot>
    </div>       
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useMotion } from '@vueuse/motion';

const target = ref(null);

onMounted(() => {
    if (target.value) {
        const motionInstance = useMotion(target, {
            initial: {
                opacity: 0,
                y: 20,
            },
            enter: {
                y: 0,
                opacity: 1,
                transition: {
                    delay: 150,
                    type: 'spring',
                    stiffness: 70,
                    damping: 25,
                    mass: 1,
                },
            },
        });
        
        // Explicitly trigger the enter animation
        motionInstance.apply('enter');
    }
});

</script>